import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConnectionAuthType } from '../models/connection-auth-types.model';
import { ConnectionType } from '../models/connection-types.model';
import { ConnectionState } from '../models/get-connection-response.model';

export type ConnectionResultDetails = {
    alias: string;
    businessDomainId: string;
    businessDomainName: string;
    host: string;
    connectionType: ConnectionType;
    authType: ConnectionAuthType;
    catalog?: string;
};

@Component({
    selector: 'app-connection-result-modal',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
    templateUrl: './connection-result-modal.component.html',
    styleUrls: ['./connection-result-modal.component.scss'],
})
export class ConnectionResultModalComponent {
    @Input({ required: true }) public provisioningState!: Signal<ConnectionState | null>;
    @Input({ required: true }) public provisioningMessage!: Signal<string | null>;
    @Input({ required: true }) public provisioningElapsedTime!: () => string;
    @Input({ required: true }) public connectionResult!: Signal<ConnectionResultDetails | null>;
    @Output() public retry = new EventEmitter<void>();
    @Output() public closeRequested = new EventEmitter<void>();

    public constructor(private readonly activeModal: NgbActiveModal) {}

    protected get failureDetails(): string | null {
        const message = this.provisioningMessage();
        return message?.trim() || null;
    }

    protected close(): void {
        this.closeRequested.emit();
        this.activeModal.close();
    }

    protected retryProvisioning(): void {
        this.retry.emit();
    }

    protected closeWhilePending(): void {
        this.closeRequested.emit();
        this.activeModal.close();
    }
}
